<template><!-- svgo-optimised -->
<svg class="icon icon__Minus icon__minus" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M18.5 12.5h-13v-1h13v1Z"/></svg></template>